import { createReducer } from 'redux-create-reducer'
import { PRELOAD_DATA_ON_LOGIN } from '@disco/constants/ActionTypes'
const initialState: Array<any> = []
export type PlaylistTypesState = typeof initialState
export const playlistTypesReducer = createReducer<PlaylistTypesState, any>(
  initialState,
  {
    [PRELOAD_DATA_ON_LOGIN](_state, action) {
      return action.entities.playlistTypes || initialState
    },
  },
)
